import React from "react";

import CollapsedNavBar from "components/NavBar/CollapsedNavBar";
import FullNavBar from "components/NavBar/FullNavBar";
import useMediaQuery from "@mui/material/useMediaQuery";

function NavBar() {
  const upMd = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const courses = [
    {
      title: "Khoá Phổ thông Tiêu chuẩn",
      path: "/khoa-hoc/pho-thong-tieu-chuan",
    },
    {
      title: "Khoá Phổ thông VIP",
      path: "/khoa-hoc/pho-thong-vip",
    },
    {
      title: "Khoá Quốc tế Tiêu chuẩn",
      path: "/khoa-hoc/quoc-te-tieu-chuan",
    },
    {
      title: "Khoá Quốc tế VIP",
      path: "/khoa-hoc/quoc-te-vip",
    },
    {
      title: "Khoá Robotics & AI",
      path: "/khoa-hoc/robotics-ai",
    },
    {
      title: "Khoá Giao tiếp 1-1 với Giáo viên Nước ngoài",
      path: "/khoa-hoc/giao-tiep-giao-vien-nuoc-ngoai",
    },
    {
      title: "Câu lạc bộ Tiếng Anh Thực chiến",
      path: "/khoa-hoc/thuc-chien",
    },
  ];

  const whyUs = [
    {
      title: "40% công thức bí mật",
      path: "/diem-dac-biet?ddb=cong-thuc-bi-mat",
    },
    {
      title: "20% nguyên liệu chất lượng",
      path: "/diem-dac-biet?ddb=nguyen-lieu-chat-luong",
    },
    {
      title: "20% chuyên gia tay nghề cao",
      path: "/diem-dac-biet?ddb=chuyen-gia-tay-nghe-cao",
    },
    {
      title: "10% trang trí hài hoà",
      path: "/diem-dac-biet?ddb=trang-tri-hai-hoa",
    },
    {
      title: "10% phục vụ chu đáo",
      path: "/diem-dac-biet?ddb=phuc-vu-chu-dao",
    },
  ];

  const company = [
    {
      title: "Giới thiệu",
      path: "/gioi-thieu",
    },
    {
      title: "Blog",
      path: "/blog",
    },
  ];

  if (upMd) {
    return <FullNavBar courses={courses} whyUs={whyUs} company={company} />;
  }

  return <CollapsedNavBar courses={courses} whyUs={whyUs} company={company} />;
}

export default NavBar;
